import type {EmblaCarouselType, EmblaOptionsType} from 'embla-carousel'
import useEmblaCarousel from 'embla-carousel-react'

import arrowLeft from '@/assets/icons/chevron-left.svg'
import arrowRight from '@/assets/icons/chevron-right.svg'

import style from './Slider.module.scss'

interface Props {
  ref?: Ref<EmblaCarouselType | undefined>
  wrapperProps?: ComponentProps<'div'>
  carouselOptions?: EmblaOptionsType
}

const Slider = deepMemo<PropsWithChildren<Props>>(function Slider({
  ref,
  children,
  wrapperProps,
  carouselOptions,
}) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'start',
    // slidesToScroll: 'auto',
    ...carouselOptions,
  })

  useImperativeHandle(ref, () => {
    return emblaApi
  }, [emblaApi])

  // Prev, Next button
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev()
  }, [emblaApi])

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext()
  }, [emblaApi])

  const onSelect = useStableCallback((emblaApi: EmblaCarouselType) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev())
    setNextBtnDisabled(!emblaApi.canScrollNext())
  })

  useEffect(() => {
    if (!emblaApi) return

    onSelect(emblaApi)
    emblaApi.on('reInit', onSelect)
    emblaApi.on('select', onSelect)

    return () => {
      emblaApi.off('reInit', onSelect)
      emblaApi.off('select', onSelect)
    }
  }, [emblaApi])

  return (
    <div {...wrapperProps}>
      <div className={style.CarouselWrapper}>
        <div ref={emblaRef} className={style.CarouselContainer}>
          <div className={style.Carousel}>{children}</div>
        </div>
        {!prevBtnDisabled && (
          <button className={clsx(style.Arrow, style.ArrowLeft)} onClick={scrollPrev}>
            <img src={arrowLeft} alt='Previous slide' />
          </button>
        )}
        {!nextBtnDisabled && (
          <button className={clsx(style.Arrow, style.ArrowRight)} onClick={scrollNext}>
            <img src={arrowRight} alt='Next slide' />
          </button>
        )}
      </div>
    </div>
  )
})()

export default Slider
